import { Link, useNavigate } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import CustomerList from "features/storages/customers/customerList"
import Callout from "components/callout/callout"
import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import RightSidebar from "components/sidebar/right/RightSidebar"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import SectionHeaderActions from "components/layout/sectionHeaderActions"
import Button from "components/inputs/button"
import { ReactComponent as AddIcon } from "assets/icons/add.svg"
import PageTitle from "features/navigation/pageTitle"
import useAccess from "@/hooks/useAccess"
import useCustomers from "@/hooks/useCustomers"
import useStorages from "@/hooks/useStorages"
import { paramGuardStorage } from "@/utils/paramGuard"
import { AccessRole, DeviceSize, FormStatus } from "@/types"
import IconButton from "@/components/buttons/iconButton"
import useWindowDimensions from "@/hooks/useWindowDimensions"
import { MainSheetHeaderActions } from "@/components/layout/layoutChrome"

const Customers = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const { displayIfSize } = useWindowDimensions()

    const { targetStorageDocId: storageId } = useTargetStorage()
    
    const { customersStatus } = useCustomers({ storageId })
    const { 
        storage,
        storageStatus,
        isCustomersEnabled
    } = useStorages({ storageId })
    
    const {
        limitToRoles
    } = useAccess({ storageId: storageId || '' })

    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    // Redirect if customers are disabled for this storage
    if (!isCustomersEnabled()) {
        navigate(`/storage`);
        return <></>;
    }

    // Return the JSX.
    return (
        <>
            <PageTitle title={t('titleCustomers')} />
            <MainSheetHeaderActions>
                { limitToRoles([AccessRole.OWNER, AccessRole.EDITOR]) && (
                    displayIfSize([DeviceSize.SM]) ?
                    <IconButton to={`/storages/${safeStorageId}/customers/create`} colorScheme="blue" className="visible md:invisible"><AddIcon /></IconButton> :
                    <Button wideOnMobile design="primary" to={`/storages/${safeStorageId}/customers/create`} className="invisible md:visible"><AddIcon /><span>{t(`buttonNewCustomer`)}</span></Button>
                )}
            </MainSheetHeaderActions>
            <Callout type="info" id={`customer-page-info`}>{t('customersInfo')}</Callout>
            <Section padX={false}>
                <CustomerList storageId={safeStorageId} />
            </Section>
            <RightSidebar />
        </>
    )
}

export default Customers
